<template lang="pug">
  .fill-in-quotation(v-loading="loading")
    .shortcut-subFinalScope-titleBar
      title-bar
        span {{ $t('供应商报价信息') }}
        span(
          v-if="isVendor && subFinalScopeInfo.plan_path"
          :class="[!isFinish? 'active' : 'disabled']"
          @click="onConfirm"
        )
          i.iconfont.icon-chucun(v-if="canEdit")
          i.iconfont.icon-bianji(v-else)
    el-button(
      v-if="showConfirmQuotationBtn"
      @click="handleConfirmQuotation"
      type="text"
      style="font-size: 14px;display: flex;margin-left: auto"
      :disabled="isFinish"
    ) {{ $t('确定报价信息') }}
    p(
      v-if="!isVendor && !subFinalScopeInfo.plan_path"
      style="color:#7f838a;margin: 20px"
    ) {{ $t('供应商尚未填写报价！') }}
    div(style="margin-left: 20px")(v-else)
      el-row
        el-col(
          :span="4"
          :class="{ required: canEdit && isVendor }"
        ) {{ $t('方案') }}

        el-col(
          :span="10"
          v-if="isVendor && canEdit"
        )
          div(
            :style="{ display: 'flex',alignItems: 'center' }"
          )
            new-upload-file(
              axiosUrl="/management/subfinal/saveFile"
              :params="uploadParams"
              @loadingChange="status => loading = status"
              @uploadSuccess="res => uploadSuccess(res)"
            )
            uploaded-file-display(
              style="margin-left: 5px"
              class="uploaded-file-display"
              :fileName="plan.name"
              :downloadUrl="plan.downloadPath"
              :fileNameList="plan.files"
              width="85px"
            )
        el-col(
          v-else
          :span="20"
          :style="{ display: 'flex', alignItems: 'center' }"
        )
          a(
            v-if="plan.downloadPath"
            :href="plan.downloadPath"
            target="_blank"
          ) {{ plan.name }}
          span(v-else) —
      el-row(
        v-if="!isVendor && quotationData && quotationData.kol_download_path"
      )
        el-col(
          :span="4"
        ) KOL
        el-col(
          :span="20"
          style="display:flex"
        )
          uploaded-file-display(
            :fileName="quotationData.kol_name"
            :downloadUrl="quotationData.kol_download_path"
          )
          i.iconfont.icon-baojia1(
            style="color:#3370d2;margin-left:5px"
            @click="visible = true"
          )
      el-row
        el-col(
          :span="4"
          :class="{ required: canEdit && isVendor }"
        ) {{ $t('报价') }}
        el-col(:span="20")
          //- span(v-if="!isFinish && !isVendor") —
          fill-in-quotation(
            :viewMode="!isVendor || !canEdit",
            :data="quotationData"
            @close="onClose"
          )

    el-row(v-if="!subFinalScopeInfo.plan_path && isVendor" style="margin-left: 20px")
      el-col(:span="4" :offset="4")
        el-button(
          type="primary"
          style="width: 140px"
          @click="onSubmit"
        ) {{ $t('保存') }}

    kol-quotation-reference-dialog(
      v-if="visible"
      :visible="visible"
      :subFinalScopeVendorId="subFinalScopeVendorId"
      @cancel="visible = false"
    )

</template>

<script>
import UploadMultipleFile from '@/components/UploadMultipleFile'
import FillInQuotation from '@/components/FillInQuotation'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import TitleBar from '@/components/TitleBar'
import { normalizeQuotation } from '@/components/QuotationDialog'
import QuotationOverview from '@/components/QuotationOverview'
import { pickBy, flatten, omit } from 'lodash'
import KolQuotationReferenceDialog from '@/components/KolQuotationReferenceDialog'

const getExpressVendorQuotation = id => {
  return axios.get('/management/subfinalExpress/getExpressVendorQuotation', {
    params: {
      sub_final_scope_vendor_id: id,
      type: 1
    }
  })
}

const updateVendorQuotation = (params) => {
  return axios.post('/management/subfinalExpress/saveVendorPrice', format4backend(params))
}

const saveVendorPlan = (params) =>
  axios.post('/management/subfinalExpress/saveVendorPlan', format4backend(params))

const checkNeedDot = id => {
  return axios.get('/management/subfinalExpress/checkNeedDot', {
    params: {
      sub_final_scope_id: id
    }
  })
}

export default {
  components: {
    UploadMultipleFile,
    FillInQuotation,
    NewUploadFile,
    UploadedFileDisplay,
    TitleBar,
    QuotationOverview,
    normalizeQuotation,
    KolQuotationReferenceDialog
  },
  data () {
    return {
      plan: {
        serverPath: null,
        downloadPath: null,
        name: '',
        files: []
      },
      loading: false,
      isFinish: false, // 是否填写完成
      canEdit: false,
      isSaved: false,
      quotationParams: null,
      quotationData: null,
      subFinalScopeInfo: {},
      subFinalScopeVendorId: null,
      needDot: {
        need_dot: false,
        temp_need_dot: false
      },
      businessSetting: {},
      visible: false
    }
  },
  computed: {
    isVendor () {
      return this.$store.state.common.user.is_vendor
    },
    uploadParams () {
      return {
        file_type: 3
      }
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    showOpenDotButton () {
      return this.$store.state.common.user.permissions.indexOf('Management_Express_Dot_Open') !== -1
    },
    showConfirmQuotationBtn () {
      return this.$store.state.common.user.permissions.indexOf('Confirm_Vendor_Quotation') !== -1 && this.subFinalScopeInfo.plan_path
    },
    shouldDisableDOTBtn () {
      return !this.needDot.temp_need_dot || (this.needDot.temp_need_dot && this.subFinalScopeInfo.is_dot === 1) || this.businessSetting.parent_is_edit === 0
    }
  },
  mounted () {
    if (this.subFinalScopeId) {
      this.getSubFinalScopeInfo()
      this.checkNeedDot()
      this.getBusinessSetting()
    }
  },
  beforeRouteLeave (to, from, next) {
    if ((this.isVendor && this.canEdit && !this.isSaved)) {
      this.$confirm(this.$t('离开本页面，已更改的信息将不会被保存。'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          next()
          if (window.changeTabCB) {
            window.changeTabCB()
            window.changeTabCB = null
          }
        })
        .catch(() => {
          window.changeTabCB = null
          return next(false)
        })
    } else {
      next()
      if (window.changeTabCB) {
        window.changeTabCB()
        window.changeTabCB = null
      }
    }
  },
  methods: {
    handleConfirmQuotation () {
      this.$confirm(this.$t('报价信息确认后将不可再修改，请确定是否继续。'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          axios.get('/management/subfinalExpress/confirmQuotationInfo', {
            params: {
              sub_final_scope_id: this.subFinalScopeId
            }
          })
            .then(() => {
              this.$message.success(this.$t('确定报价信息成功'))
              this.$store.dispatch('campaign/updateSowProcess', this.subFinalScopeId)
              this.getBusinessSetting()
            })
            .catch(err => {
              throw new Error(err)
            })
        })
    },
    async getSubFinalScopeInfo () {
      try {
        this.subFinalScopeInfo = await axios.get('/management/subfinalExpress/getSubFinalScope', {
          params: {
            sub_final_scope_id: this.subFinalScopeId
          }
        })
        this.subFinalScopeVendorId = this.subFinalScopeInfo.sub_final_scope_vendor_id
        this.fetchQuotationData()
        this.plan.name = this.subFinalScopeInfo.plan_name
        this.plan.serverPath = this.subFinalScopeInfo.plan_path
        this.plan.downloadPath = this.subFinalScopeInfo.plan_download_path
        this.plan.files = this.subFinalScopeInfo.plan_name_list
        if (!this.subFinalScopeInfo.plan_path) {
          this.canEdit = true
        }
        this.$store.commit('campaign/setSubFinalScopeInfo', this.subFinalScopeInfo)
      } catch (err) {
        throw new Error(err)
      }
    },
    onClose (params) {
      params.vendor_offer_price = params.vendor_offer_price.map(i => omit(i, 'id'))
      this.quotationParams = params
    },
    async fetchQuotationData () {
      // if (this.loading) return
      if (this.subFinalScopeVendorId == null) {
        this.quotationOverviewArr = []
        return
      }
      this.loading = true
      const res = await getExpressVendorQuotation(this.subFinalScopeVendorId)
      this.quotationData = res
      this.getQuotationParams()
      this.loading = false
    },
    getQuotationParams () {
      const result = this.quotationData.vendor_price.map(category => normalizeQuotation(category))
      const serviceItem = flatten(result.map(item => item.tableData.map(o => ({ service_item_name: o.serviceItemName }))))
      this.quotationParams = {
        sub_final_scope_vendor_id: this.subFinalScopeVendorId,
        service_item: serviceItem.map(i => [{ service_item_name: i.service_item_name }]),
        vendor_offer_price: flatten(result.map(item => {
          return item.tableData.map(o => {
            const res = {
              category_id: item.categoryId,
              service_id: o.serviceId,
              unit_price: o.unitPrice,
              number: o.number,
              total_price: o.totalPrice,
              detail_path: o.detail.serverPath,
              remark: o.remark,
              solutions_name: o.solutionsName,
              price_after_leveraging: o.priceAfterLeveraging,
              coverage_start_date: o.dateRange[0],
              coverage_end_date: o.dateRange[1]
            }
            return pickBy(res, v => { return v != null })
          })
        })),
        vendor_offer_discount: result.map(o => {
          return {
            category_id: o.categoryId,
            discount: o.discount
          }
        })
      }
    },
    async onSubmit () {
      if (this.plan.serverPath == null) {
        this.$message.error(this.$t('请上传方案'))
        return
      }
      if (!this.checkQuotation()) {
        this.$message.error(this.$t('请填写报价'))
        return
      }
      this.loading = true
      const params = {
        sub_final_scope_vendor_id: this.subFinalScopeInfo.sub_final_scope_vendor_id,
        plan_path: this.plan.serverPath
      }
      const quotationParams = this.quotationParams
      quotationParams.campaign_id = this.$store.state.campaign.id
      try {
        // await axios.post('/management/subfinalExpress/saveVendorPrice', format4backend(quotationParams))
        await updateVendorQuotation(quotationParams)
        await saveVendorPlan(params)
        await this.getSubFinalScopeInfo()
        this.$emit('getSOWList')
        this.$store.dispatch('campaign/updateSubFinalScopeInfo')
        this.loading = false
        this.$message.success(this.$t('保存成功'))
        this.canEdit = false
        this.isSaved = true
      } catch (error) {
        this.loading = false
        if (error.message === this.$t('报价信息已被确认，当前更改内容将不会保存')) {
          this.$message.warning(error.message)
          this.canEdit = false
          this.isSaved = true
          this.getSubFinalScopeInfo()
          this.checkNeedDot()
          this.getBusinessSetting()
        } else {
          throw new Error(error)
        }
      }
    },
    uploadSuccess (res) {
      this.plan = {
        serverPath: res.file_path,
        downloadPath: res.file_download_path,
        name: res.file_name,
        files: res.file_name_list
      }
      this.loading = false
    },
    checkQuotation () {
      return document.querySelector('.quotation-overview .el-table') != null
    },
    onConfirm () {
      if (this.isFinish) return
      if (this.canEdit) {
        this.onSubmit()
        // this.checkSave()
      } else {
        this.canEdit = !this.canEdit
      }
    },
    // checkSave () {
    //   if (!this.isFinish) {
    //     this.onSubmit()
    //   } else {
    //     this.isSaved = true
    //     this.$message.warning(this.$t('当前页面无法编辑，请联系业务支持'))
    //     setTimeout(() => {
    //       this.$router.push('/vendor-campaign/list')
    //     }, 2000)
    //   }
    // },
    getBusinessSetting () {
      axios.get('/common/getBusinessSetting', {
        params: {
          business_id: this.subFinalScopeId, // subfinalScopeId 或 campaignId
          business_type: 2, // subFinalScope
          module_type: 2
        }
      })
        .then((res) => {
          this.isFinish = Boolean(res.is_finish)
        })
    },
    handleOpenDotProcess () {
      this.$confirm(this.$t('开启社交监测后，将无法调整SOW信息与报价。'), this.$t('提示'), {
        confirmButtonText: this.$t('确定开启'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          this.confirmOpenDotProcess()
        })
        .catch(() => {})
    },
    confirmOpenDotProcess () {
      this.loading = true
      axios.get('/management/subfinalExpress/openDotProcess', {
        params: {
          sub_final_scope_id: this.subFinalScopeId,
          campaign_id: this.$store.state.campaign.id
        }
      })
        .then(() => {
          this.loading = false
          this.needDot.temp_need_dot = false
          this.$message.success(this.$t('开启DOT流程成功'))
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    async checkNeedDot () {
      const res = await checkNeedDot(this.subFinalScopeId)
      this.needDot = {
        need_dot: res.need_dot,
        temp_need_dot: res.need_dot
      }
    }
  }
}
</script>

<style lang="stylus">
.fill-in-quotation
  .uploaded-file-display
    span
      width auto !important
</style>
